import { render, staticRenderFns } from "./ProductGenres.vue?vue&type=template&id=566b8173&scoped=true"
import script from "./ProductGenres.vue?vue&type=script&lang=js"
export * from "./ProductGenres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b8173",
  null
  
)

export default component.exports